import React, { useEffect, useState } from 'react';
import { Table, message } from 'antd';
import api from '../../../config/axios';
import { getOrderForms, tax } from '../../../config/api-routes';
import { ColumnsType } from 'antd/es/table';
import { OrderForm } from '../../../schema/order';
const OrderFormConfig = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [dataSource, setDataSource] = useState<OrderForm[]>([]);

  const taxesTable: ColumnsType<OrderForm> = [
    {
      title: 'Order Form Title',
      dataIndex: 'title',
      width:250,
      align: 'left',
    },
    {
      title: 'year',
      dataIndex: 'year',
      align: 'center',
    },
    {
      title: 'isDiscountAmountBased',
      dataIndex: 'isDiscountAmountBased',
      render: (data) => data ? 'True': 'False', 
      align: 'center',
    },
    {
      title: 'isTierQuantityBased',
      dataIndex: 'isTierQuantityBased',
      
      render: (data) => data ? 'True': 'False',
      align: 'center',
    },
    {
      title: 'isTierSameForAll',
      dataIndex: 'isTierSameForAll',
      render: (data) => data ? 'True': 'False',
      align: 'center',
    },
  ];
  const getTaxes = () => {
    setLoading(true);

    api
      .get<never, OrderForm[]>(getOrderForms)
      .then((res) => {
        const response = res.filter((ele)=> !ele.title.toLocaleLowerCase().includes('delete') );
        setDataSource(response);
        setLoading(false);
      })
      .catch((error: any) => {
        message.error(error?.response?.data?.message);
      });
  };

  useEffect(() => {
    getTaxes();
  }, []);

  return (
    <div className='mx-2'>
      <h3 className='title-grey'>Order Form Configs</h3>
      <Table
        columns={taxesTable}
        dataSource={dataSource}
        loading={loading}
        pagination={false}
        rowKey='taxCode'
      />
    </div>
  );
};

export default OrderFormConfig;
